import React from "react";
import Box from "@mui/material/Box";
import Banner from "../../assets/images/Banner.png";

const MainImageHeader: React.FC = () => {
  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
          height: { xs: "200px", md: "265px", xl: "435px" },
        }}
      >
        <img
          src={Banner}
          alt=""
          width="100%"
          height="100%"
          style={{
            opacity: 1,
            objectFit: "cover",
            maxWidth: "100%",
            maxHeight: "100%",
            display: "block",
          }}
        />
      </Box>
    </React.Fragment>
  );
};

export default MainImageHeader;
